import { Building2, Camera, ClipboardList, House, Map, Search, Store } from 'lucide-react';

import { ROUTES } from '@/config/routes';
import type { WorkspaceFeature } from '@/config/workspace-features';
import { useAuthStore } from '@/stores/auth';

const M = ROUTES.workspace.mobile;

/**
 * 하단 탭(#204) — 공고 둘·고객사 둘(지도사), 홈·우리 회사(기업 회원, specs/065). 허용된 첫 탭이 모바일 첫 화면이다(지도사 = 공고 검색, 기업 = 홈).
 * `feature` 가 세션 기능 목록에 있는 탭만 보인다(specs/064). `active` 는 현재 경로가 이 탭 소속인지. 등록 경로는 고객사 하위 주소지만 "고객사 등록" 탭 소속이다.
 */
export const MOBILE_TABS = [
  {
    to: M.home,
    label: '홈',
    feature: 'COMPANY_HOME',
    icon: House,
    active: (path: string) => path.startsWith(M.home),
  },
  {
    // 기업 공고 찾기(specs/069) — 기업 셀프 묶음 탭. 화면 라우트가 판정 기능도 함께 요구한다
    to: M.myAnnouncements,
    label: '공고 찾기',
    feature: 'COMPANY_HOME',
    icon: Search,
    active: (path: string) => path.startsWith(M.myAnnouncements),
  },
  {
    // 기업 성장 로드맵(specs/071) — 화면이 ROADMAP 기능도 확인한다
    to: M.myRoadmap,
    label: '로드맵',
    feature: 'COMPANY_HOME',
    icon: Map,
    active: (path: string) => path.startsWith(M.myRoadmap),
  },
  {
    to: M.myCompany,
    label: '우리 회사',
    feature: 'COMPANY_HOME',
    icon: Store,
    active: (path: string) => path.startsWith(M.myCompany),
  },
  {
    to: M.search,
    label: '공고 검색',
    feature: 'ANNOUNCEMENT_FINDER',
    icon: Search,
    active: (path: string) =>
      path.startsWith(M.search) || path.startsWith(`${M.root}/announcements`),
  },
  {
    to: M.consultantAnnouncements,
    label: '컨설턴트 공고',
    feature: 'CONSULTANT_ANNOUNCEMENT',
    icon: ClipboardList,
    active: (path: string) => path.startsWith(M.consultantAnnouncements),
  },
  {
    to: M.companies,
    label: '고객사',
    feature: 'MULTI_COMPANY',
    icon: Building2,
    active: (path: string) => path.startsWith(M.companies) && path !== M.companyNew,
  },
  {
    to: M.companyNew,
    label: '고객사 등록',
    // 고객사를 여럿 관리하는 회원의 탭 — 기업 회원은 우리 회사 탭에서 등록한다(specs/065).
    feature: 'MULTI_COMPANY',
    icon: Camera,
    active: (path: string) => path === M.companyNew,
  },
] as const satisfies readonly { feature: WorkspaceFeature; [key: string]: unknown }[];

/** 세션 기능 목록에 있는 탭만 — 첫 탭이 모바일 첫 화면이다(축 분기 없음, specs/065 FR-008). */
export function useMobileTabs() {
  const features = useAuthStore((st) => st.features);
  return MOBILE_TABS.filter((t) => features.includes(t.feature));
}
